import React from 'react';
import s from './Buttons.module.css';
type Props = {
	name: string;
	onClickButton?: () => void;
	type?: 'button' | 'submit' | 'reset';
	color: 'blue' | 'brownButton';
	active?: boolean;
};
const PanelButton: React.FC<Props> = ({
	name,
	onClickButton,
	type,
	color,
	active,
}) => {
	return (
		<button
			type={type}
			className={`${s[color]} ${s.brownButton} ${active ? s.active : ''}`}
			onClick={onClickButton}
		>
			{name}
		</button>
	);
};

export default PanelButton;
